module.exports = __webpack_public_path__ + "media/svg/symbols-35d7f562.svg";